// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_pages_module_ts":"4c92d9632cf59a20","src_app_pages_wd_wd_module_ts":"d3a34c78d35e79e0"}[chunkId] + ".js";
};